import {
  FAILURE_STATUS,
  IDLE_STATUS,
  LOADING_STATUS,
  LoadingType,
  SUCCESS_STATUS,
} from '../utils/types/statuses';
import { IValidationErrorResponse } from './auth/asyncThunk';

interface I401 {
  status: string;
  message: string;
}

export interface IResponseError {
  statusCode: number | null;
  data: (IValidationErrorResponse & I401) | null | any;
}

export type StatusType = {
  status: LoadingType;
  error: IResponseError;
  [key: string]: any;
};

export type TRequest = {
  error: IResponseError;
  status: LoadingType;
};

export const RESPONSE_DEFAULT_ERROR = {
  data: null,
  statusCode: null,
};

export const setFetchingRequest = (state: StatusType): void => {
  state.status = LOADING_STATUS;
  state.error = { ...RESPONSE_DEFAULT_ERROR };
};
export const setFetchingSuccess = (state: StatusType): void => {
  state.status = SUCCESS_STATUS;
  state.error = { ...RESPONSE_DEFAULT_ERROR };
};
export const setFetchingError = (state: StatusType, error: any): void => {
  state.status = FAILURE_STATUS;
  state.error = error;
};
export const clearState = (state: StatusType): void => {
  state.status = IDLE_STATUS;
  state.error = { ...RESPONSE_DEFAULT_ERROR };
};
export const baseRequestState: TRequest = {
  error: {
    statusCode: null,
    data: null,
  },
  status: IDLE_STATUS,
};
